/**
 * Full-page deviations list (/deviations). Requires OrgProvider.
 */

import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DeviationList from './DeviationList';
import { useOrg } from '../../hooks/useOrg';
import './DeviationsStandalone.css';

const DEV_ROLES = new Set([
  'management',
  'ic_personnel',
  'administration',
  'admin',
  'Management',
  'IC_Personnel',
  'Administration',
  'Admin'
]);

export default function DeviationsStandalone({ userData, userRole, homePath = '/' }) {
  const { t } = useTranslation('deviations');
  const { activeOrgId, organizationIds } = useOrg();
  const orgId =
    activeOrgId || (Array.isArray(organizationIds) && organizationIds.length > 0 ? organizationIds[0] : null);

  if (!DEV_ROLES.has(userRole)) {
    return <Navigate to={homePath} replace />;
  }

  return (
    <div className="deviations-standalone">
      <header className="deviations-standalone__header">
        <Link className="deviations-standalone__back" to={homePath}>
          ← {t('backToDashboard')}
        </Link>
        <span className="deviations-standalone__title">{t('title')}</span>
      </header>
      <main className="deviations-standalone__main">
        {!orgId ? (
          <div className="deviations-standalone__loading">
            <p>{t('noOrganization')}</p>
          </div>
        ) : (
          <DeviationList organizationId={orgId} userId={userData?.uid} userRole={userRole} />
        )}
      </main>
    </div>
  );
}
